import { LinkedIn, WhatsApp, YouTube } from "@mui/icons-material";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Box, IconButton, Link, Stack, Typography } from "@mui/material";
import { IThemeConfig } from "../../../../types/memorial-types";

interface Template2FooterProps {
  memorialTheme: IThemeConfig;
  contactPhone?: string;
  contactEmail?: string;
  facebookUrl?: string;
  linkedinUrl?: string;
  youtubeUrl?: string;
  whatsappUrl?: string;
}

export default function Template2Footer({
  memorialTheme,
  contactPhone = "+263 77 640 2402",
  contactEmail = "cas@area46.co.zw",
  facebookUrl = "https://www.facebook.com/share/18wBS1THMb/",
  linkedinUrl = "https://www.linkedin.com/company/muzukuru/",
  youtubeUrl = "https://www.youtube.com/@Muzukuru",
  whatsappUrl = "https://wa.me/263776402402",
}: Template2FooterProps) {
  const iconColor = memorialTheme.primary || "#825639";

  const socialLinks = [
    { Icon: FacebookIcon, href: facebookUrl },
    { Icon: LinkedIn, href: linkedinUrl },
    { Icon: YouTube, href: youtubeUrl },
    { Icon: WhatsApp, href: whatsappUrl },
  ].filter((s) => Boolean(s.href));

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "transparent",
        px: { xs: 3, sm: 6, md: 14, lg: 18 },
        py: { xs: 3, sm: 3.5 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 2, sm: 2 },
        }}
      >
        <Stack
          direction="row"
          spacing={2.5}
          alignItems="center"
          flexWrap="wrap"
          rowGap={0.75}
        >
          <Typography
            sx={{ fontSize: 15, color: "text.secondary", fontWeight: 500 }}
          >
            © {new Date().getFullYear()} Muzukuru
          </Typography>
          <Box
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              bgcolor: "rgba(0,0,0,.2)",
            }}
          />
          <Link
            href={`tel:${contactPhone.replace(/\s+/g, "")}`}
            underline="hover"
            sx={{
              fontSize: 15,
              color: "text.secondary",
              "&:hover": { color: iconColor },
            }}
          >
            {contactPhone}
          </Link>
          <Box
            sx={{
              width: 4,
              height: 4,
              borderRadius: "50%",
              bgcolor: "rgba(0,0,0,.2)",
            }}
          />
          <Link
            href={`mailto:${contactEmail}`}
            underline="hover"
            sx={{
              fontSize: 15,
              color: "text.secondary",
              "&:hover": { color: iconColor },
            }}
          >
            {contactEmail}
          </Link>
        </Stack>
        
        <Stack direction="row" spacing={1}>
          {socialLinks.map(({ Icon, href }, index) => (
            <IconButton
              key={index}
              component="a"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{
                color: "text.secondary",
                bgcolor: "rgba(0,0,0,.03)",
                width: 36,
                height: 36,
                transition: "all .15s ease",
                "&:hover": {
                  color: "#fff",
                  bgcolor: iconColor,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Icon fontSize="small" />
            </IconButton>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}